export const cart = {
	cartDetails: {
		empty: {
			title: 'Your shopping cart is empty',
			description:
				'Before starting a checkout, you must add some products to your cart. You will find a lot of interesting products in our catalog.',
			youMayLike: 'You may also like',
		},
	},
	cartItems: {
		id: 'Model',
		part: 'Part',
		orderItems: 'Order Items ({{count}} item)',
		addConsumerDetails: 'Add Consumer Details',
		addBuilderDetails: 'Add Builder Details',
		consumerDetails: 'Consumer Details',
		builderDetails: 'Builder Details',
	},
	voucher: {
		coupon: 'Have a promo code?',
	},
	orderCost: {
		subTotal: 'Subtotal:',
		specialHandling: 'Special Handling:',
		taxes: 'Taxes:',
		adjustment: 'Adjustment:',
		tradeDiscounts: 'Trade Discounts:',
		promoDiscounts: 'Promo Discounts:',
		shippingExtended: 'Shipping (Finished Goods):',
		servicePartsDeliveryCost: 'Estimated Shipping (Service Parts):',
		grandTotal: 'Grand total:',
		tbd: 'TBD',
		thirdPartyShippingCost: 'Third Party Shipping',
	}
};